import React from 'react'
import FilterDropdown from '../../common/AppSpecificConpnents/PartsTable/FilterDropdown'


const TaskCustomFilter = ({
    isDropdownOpen,
    setIsDropdownOpen,
    filterType,
    setFilterType,
    disableFilter
}) => {
    const filterOptions = [
        { value: "all", label: "All Tasks" },
        { value: "assigned_or_owned", label: "Tasks Assigned to or Owned by Me" },
        { value: "on_this_page", label: "Tasks On This Page" },
        { value: "for_selection", label: "Tasks For Selection" },
        { value: "open_tasks", label: "Open Tasks For Selection" },
    ]
  return <>
    <FilterDropdown
        isDropdownOpen={isDropdownOpen}
        setIsDropdownOpen={setIsDropdownOpen}
        filterType={filterType}
        setFilterType={setFilterType}
        filterOptions={filterOptions}
        width="220px"
        usingInPopup={true}
        disableFilter={disableFilter}
    />
  </>
}

export default TaskCustomFilter